// extracted by mini-css-extract-plugin
export default {"model":"Model_model__cqGCf","model__view":"Model_model__view__M3GAs"};